import React from 'react';
import { FormattedMessage } from 'react-intl';
import { Responsive } from 'src/utils/index';
import { IAmenities, IHotelDetails } from 'src/common-types/index';
import { AmenityComponent } from '../amenity';
import './style.scss';

interface IProps {
  hotel: IHotelDetails;
  refAnchor: React.RefObject<HTMLDivElement>;
}

class AmenitiesComponent extends React.Component<IProps, null> {
  searchAmenities = (nameGroup: string): IAmenities[] => {
    return (this.props.hotel.amenities || []).filter(
      (amenity) => amenity.categoryName === nameGroup,
    );
  };

  render(): React.ReactNode {
    const { hotel, refAnchor } = this.props;
    const { amenityDescriptions } = hotel;

    return (
      <div className="amenities" ref={refAnchor}>
        <h4 className="amenities__title">
          <FormattedMessage id="tab.amenities" />
        </h4>
        {!!(amenityDescriptions && amenityDescriptions.length) &&
          amenityDescriptions.map((description, index) => (
            <p key={index} className="amenities__description">
              {description}
            </p>
          ))}
        <div className="amenities__amenities-list">
          <Responsive>
            <AmenityComponent amenities={this.searchAmenities('General')} />
          </Responsive>
          <div className="amenities__items amenities__default-markup">
            <Responsive>
              <AmenityComponent amenities={this.searchAmenities('Food & Drink')} />
            </Responsive>
            <Responsive>
              <AmenityComponent amenities={this.searchAmenities('Wellness Facilities')} />
            </Responsive>
            <Responsive>
              <AmenityComponent amenities={this.searchAmenities('Entertainment & Activities')} />
            </Responsive>
          </div>
          <div className="amenities__items">
            <Responsive>
              <AmenityComponent amenities={this.searchAmenities('Safety')} />
            </Responsive>
            <Responsive>
              <AmenityComponent amenities={this.searchAmenities('Services')} />
            </Responsive>
            <Responsive>
              <AmenityComponent amenities={this.searchAmenities('Accessibility')} />
            </Responsive>
            <div className="amenities__tablet-markup">
              <Responsive>
                <AmenityComponent amenities={this.searchAmenities('Food & Drink')} />
              </Responsive>
              <Responsive>
                <AmenityComponent amenities={this.searchAmenities('Wellness Facilities')} />
              </Responsive>
              <Responsive>
                <AmenityComponent amenities={this.searchAmenities('Entertainment & Activities')} />
              </Responsive>
            </div>
          </div>
          <div className="amenities__items">
            <Responsive>
              <AmenityComponent amenities={this.searchAmenities('Parking')} />
            </Responsive>
            <Responsive>
              <AmenityComponent amenities={this.searchAmenities('Other')} />
            </Responsive>
          </div>
        </div>
      </div>
    );
  }
}

export const Amenities = AmenitiesComponent;
